import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {requestContext} from '../../common/requestContext';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {Maybe} from '../../graphql/generated/types';

/**
 * 페이지 오픈 로그 저장
 *
 * Origin: pageNicolasApi.openPage
 * API: POST /api/v5/inven/open_page
 */
export async function postInvenOpenPage(
  {
    seriesId,
    productId,
    ticketUid,
  }: {
    seriesId: number;
    productId: number;
    ticketUid?: Maybe<bigint>;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {open_log: {transaction_id: string}}> {
  const {deviceId} = requestContext.requestInfo;
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/inven/open_page',
    {
      method: 'POST',
      data: {
        seriesId,
        productId,
        // 필수값은 아니지만 비로그인 상태에 유의미하게 사용하는 값이라 데이터분석팀 요청으로 추가합니다.
        transactionId: deviceId,
        ticket_uid: ticketUid,
      },
    },
    options
  );
  return response.data;
}
